import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AgmCoreModule } from "@agm/core";
import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator/ngx';
import { HttpClient } from '@angular/common/http';



@Component({
  selector: 'app-parking',
  templateUrl: './elevator.page.html',
  styleUrls: ['./elevator.page.scss'],
})
export class ElevatorPage {
	
	week_days = {
		it: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
		en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	  };
	language = localStorage.getItem("language_select");
	opening_days: string[] = [];	
	week_status: { day: string, isOpen: boolean }[] = [];
	day_hours: number[] = Array.from({ length: 24 }, (_, i) => i);
  	opening_hours_status: { hour: number, isOpen: boolean }[] = [];
	dt:any={};
	weekDays: { [key: string]: string[] } = {
		en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		it: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato']
	};

	
	constructor( private route : ActivatedRoute, private http: HttpClient ) { 
	
	}

	ionViewWillEnter(){
		this.http.get("https://api.infoparkingamalfi.com/elevator/status/"+this.route.snapshot.paramMap.get('id')).subscribe( data => {
			this.dt = data;
			if( this.dt.timetable ){
				this.dt.timetable.forEach(item => {
					item.opening_day = [...item.opening_day.filter(day => day !== 0), ...item.opening_day.filter(day => day === 0)];
				});
			}
			this.language = localStorage.getItem("language_select");
			//console.log( this.dt );
		});
	}

}
